import { render, staticRenderFns } from "./CalendarioDentalia.vue?vue&type=template&id=98d9b5f4&scoped=true"
import script from "./CalendarioDentalia.vue?vue&type=script&lang=js"
export * from "./CalendarioDentalia.vue?vue&type=script&lang=js"
import style0 from "./CalendarioDentalia.vue?vue&type=style&index=0&id=98d9b5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d9b5f4",
  null
  
)

export default component.exports